import { computed, Directive, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TDeliverableForm } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/deliverable-list.interface';
import { ICtaAnalyticsData } from '@cta-analytics-dialog/cta-analytics-dialog-content/cta-analytics-table/cta-analytics-table.interface';
import { EDeliverableType, EPlatformFeature } from '@enums/campaign.enum';
import { SocialUtilitiesService } from '@utilities/social-utilities.service';
import { IManualDeliverableStatusConfig } from '../cta-analytics-dialog-content/cta-analytics-table/cta-analytics-details/cta-analytics-details-deliverable-card/manual-deliverable-status/manual-devlierable-status.interface';

@Directive({
  selector: '[appDeliverableAnalyticsContent]',
})
export class DeliverableAnalyticsContentDirective {
  public readonly deliverableForm = input.required<FormGroup<TDeliverableForm>>();
  public readonly deliverableId = input.required<string | null>();
  public readonly deliverableType = input.required<EDeliverableType>();
  public readonly executionAnalytics = input.required<ICtaAnalyticsData | null>();
  public readonly platformFeature = input.required<EPlatformFeature>();
  public readonly manualDeliverableStatusConfig = input.required<IManualDeliverableStatusConfig>();

  public readonly EPlatformFeature = EPlatformFeature;
  public readonly EDeliverableType = EDeliverableType;

  public readonly platform = computed(() => SocialUtilitiesService.getPlatform(this.platformFeature()));
}
